//Imagen
import banner768 from '../../../Activos/Imagenes/BannerHome/banner768.svg';

export const ComponenteExtra768Style = {
    DivStyle: {
        display: 'flex',
        justifyContent: 'flex-start',
        paddingLeft: 40,
        backgroundImage: 'url(' + banner768 + ')',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        alignItems: 'center',
        gap: 20,
        height: 95,
        width: 'auto'
    },
    ImgStyle: {
        width: '267px',
        height: '45px',
    }
};